
/**
 *  02/04/2019 v 1.0 - JuanMa
 *  v1.1 10/10/2019 Añadida funcion getValorPropiedad
 *  v1.2 25/10/2019 Añadida comparacion recursiva cuando se encuentra un campo q es un objeto.
 *  v1.3 24/03/2020 Añadida la función objetoEsVacío para reconocer un caso {}
 *  v1.4 01/04/2020 Añadida comprobación de null en la función getValorPropiedad
 **/

export const compararObjetos = (a, b) => {
    /*
    console.log("COMPARAR OBJETOS");
    console.log(a);
    console.log(b);
    */
    if (!a || !b){ //Si alguno de los dos es null
        if ( (a && !b) || (!a || b) ) {
            //console.log("D1");
            return false;
        }
        else
            return true; //caso !a && !b
    }

    var aKeys = Object.keys(a).sort();
    var bKeys = Object.keys(b).sort();
    if (aKeys.length !== bKeys.length) {
        //console.log("D2");
        return false;
    }
    if (aKeys.join('') !== bKeys.join('')) {
        //console.log("D3");
        return false;
    }
    for (var i = 0; i < aKeys.length; i++) {
        if (typeof a[aKeys[i]] === 'object'){
            //console.log("D4a");
            return compararObjetos(a[aKeys[i]],b[bKeys[i]]);
        }
        else{
            if ( a[aKeys[i]] != b[bKeys[i]]) {
                console.log("D5");
                console.log(aKeys[i]);
                console.log(a[aKeys[i]]);
                console.log(bKeys[i]);
                console.log(b[bKeys[i]]);
                return false;
            }
        }
    }
    //console.log("D6: TRUE");
    return true;
}

export const compararArrays = (a, b) => {
    if (!a || !b){ //Si alguno de los dos es null
        if ( (a && !b) || (!a || b) )
            return false;

        else
            return true; //caso !a && !b
    }

    if (!Array.isArray(a) || !Array.isArray(b))
        return false;


    if (a.length != b.length)
        return false;

    a.forEach( (itemA, index) => {
        let itemB= b[index];
        let comparacion= compararObjetos(itemA, itemB);
        if (!comparacion)
            return false;
    });

    return true;
}



export const getValorPropiedad= (objeto, propiedad) => {
    /*
    console.log("*** getValorPropiedad");
    console.log(objeto);
    console.log("propiedad: " + propiedad);
    */

    let partesPropiedad = propiedad.split(".");
    let resultado=  null;
    let valorEsNull= false;
    partesPropiedad.forEach( (subPropiedad) => {
        if (!valorEsNull) {
            if (!resultado) {
                resultado = objeto[subPropiedad];
                if (!resultado)
                    valorEsNull = true;
            } else {
                resultado = resultado[subPropiedad];
            }
        }
    });
    return resultado;
}

export const objetoEsVacio= (objeto) => {
    return Object.keys(objeto).length === 0 && objeto.constructor === Object;
}